<div class="user-row analytics-card-host" [class.is-refreshing]="isLoading()">
  <!-- Left Card: Top PureOriginal Users -->
  <div class="user-card">
    <div class="card-header with-toggle">
      <h3>Top PureOriginal Users</h3>
      <div class="granularity-toggle">
        <button [class.active]="poGranularity() === 'DAY'" (click)="onPoGranularityChange('DAY')">Day</button>
        <button [class.active]="poGranularity() === 'WEEK'" (click)="onPoGranularityChange('WEEK')">Week</button>
        <button [class.active]="poGranularity() === 'MONTH'" (click)="onPoGranularityChange('MONTH')">Month</button>
      </div>
    </div>

    <div class="card-body">
      <div class="bar-chart" *ngIf="aggregatedPoUsers.length > 0">
        <div class="bar-row" *ngFor="let user of aggregatedPoUsers; let i = index">
          <div class="bar-user">
            <div class="avatar" [style.background]="getAvatarGradient(i)">
              {{ getInitials(user.firstName, user.lastName) }}
            </div>
            <span class="bar-user-name">{{ user.firstName }} {{ user.lastName }}</span>
          </div>
          <div class="bar-track-wrapper">
            <div class="bar-track">
              <div class="bar-fill" [style.width]="getPoBarWidth(user.total)" [style.background]="getBarColor(i)"></div>
            </div>
            <span class="bar-value">{{ user.total | number }}</span>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="!isPoLoading() && aggregatedPoUsers.length === 0">
        <span class="empty-text">{{ poLoadFailed() ? 'Could not load user data' : 'No user data available' }}</span>
      </div>
    </div>
  </div>

  <!-- Right Card: Master Upload Stats -->
  <div class="user-card">
    <div class="card-header with-toggle">
      <h3>Master Upload Stats</h3>
      <div class="granularity-toggle">
        <button [class.active]="masterGranularity() === 'DAY'" (click)="onMasterGranularityChange('DAY')">Day</button>
        <button [class.active]="masterGranularity() === 'WEEK'" (click)="onMasterGranularityChange('WEEK')">Week</button>
        <button [class.active]="masterGranularity() === 'MONTH'" (click)="onMasterGranularityChange('MONTH')">Month</button>
      </div>
    </div>

    <div class="card-body">
      <!-- Stat Tiles -->
      <div class="stats-grid">
        <button type="button" class="stat-tile" [disabled]="masterStatsLoading() || !totalUploaded"
                (click)="openMasterActivity('UPLOADED', totalUploaded)">
          <span class="stat-value">{{ totalUploaded | number }}</span>
          <span class="stat-label">Uploaded</span>
        </button>
        <button type="button" class="stat-tile" [disabled]="masterStatsLoading() || !totalUpdated"
                (click)="openMasterActivity('UPDATED', totalUpdated)">
          <span class="stat-value">{{ totalUpdated | number }}</span>
          <span class="stat-label">Updated</span>
        </button>
      </div>

      <!-- Top Uploaders with own granularity -->
      <div class="uploaders-section">
        <div class="uploaders-header">
          <h4 class="section-title">Top Uploaders</h4>
        </div>

        <div class="bar-chart" [class.expanded]="showAllUploaders()" *ngIf="aggregatedUploaders.length > 0">
          <div class="bar-row" *ngFor="let uploader of visibleUploaders; let i = index; trackBy: trackUploader">
            <div class="bar-user">
              <div class="avatar" [style.background]="getAvatarGradient(i)">
                {{ getUploaderInitials(uploader.name) }}
              </div>
              <span class="bar-user-name">{{ uploader.name }}</span>
            </div>
            <div class="bar-track-wrapper">
              <div class="bar-track">
                <div class="bar-fill" [style.width]="getUploaderBarWidth(uploader.total)" [style.background]="getBarColor(i)"></div>
              </div>
              <span class="bar-value">{{ uploader.total | number }}</span>
            </div>
          </div>
        </div>

        <button
          *ngIf="aggregatedUploaders.length > defaultVisibleUploaders"
          type="button"
          class="uploaders-toggle"
          [attr.aria-expanded]="showAllUploaders()"
          (click)="toggleUploaders()"
        >
          {{ showAllUploaders() ? 'Show less' : 'Show more' }}
          <i class="bi" [ngClass]="showAllUploaders() ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
        </button>

        <div class="empty-state" *ngIf="!isLoading() && aggregatedUploaders.length === 0">
          <span class="empty-text">No uploader data available</span>
        </div>
      </div>
    </div>
  </div>
</div>

<dialog #masterActivityDialog class="activity-dialog" (close)="onMasterActivityClosed()" aria-labelledby="master-activity-title">
  <div class="activity-heading">
    <div>
      <p class="activity-eyebrow">Master activity</p>
      <h2 id="master-activity-title">{{ masterActivityTarget() === 'UPLOADED' ? 'Uploaded Masters' : 'Updated Masters' }}</h2>
      <p class="activity-range">{{ masterActivityRangeLabel() }}</p>
    </div>
    <button type="button" class="activity-close" (click)="closeMasterActivity()" aria-label="Close Master activity list" title="Close">×</button>
  </div>
  <p *ngIf="masterActivityLoading()" class="activity-state" role="status">Loading Masters…</p>
  <div *ngIf="masterActivityError()" class="activity-state" role="alert">
    Could not load Masters. <button type="button" class="activity-retry" (click)="retryMasterActivity()">Try again</button>
  </div>
  <ng-container *ngIf="masterActivityPage() as page">
    <p class="activity-count">{{ page.totalElements | number }} files</p>
    <div class="activity-scroll" *ngIf="page.content.length; else noMasterActivity">
      <table class="activity-table">
        <thead><tr><th scope="col">ID</th><th scope="col">WinOLS reference</th><th scope="col">{{ masterActivityTarget() === 'UPLOADED' ? 'Uploaded at' : 'Updated at' }}</th><th scope="col"><span class="activity-sr-only">Open Master</span></th></tr></thead>
        <tbody>
          <tr *ngFor="let row of page.content" tabindex="0" role="button"
              [attr.aria-label]="'Open Master ' + row.masterId"
              (click)="openMasterActivityDetails(row)"
              (keydown.enter)="openMasterActivityDetails(row)"
              (keydown.space)="$event.preventDefault(); openMasterActivityDetails(row)">
            <td>{{ row.masterId }}</td>
            <td [title]="row.winOlsReference || ''">{{ row.winOlsReference || '—' }}</td>
            <td>{{ formatMasterActivityDate(row.dateTime) }}</td>
            <td class="activity-arrow" aria-hidden="true">↗</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #noMasterActivity><p class="activity-state">No Masters in this period.</p></ng-template>
    <nav class="activity-pagination" *ngIf="page.totalPages > 1" aria-label="Master activity pages">
      <button type="button" (click)="goToMasterActivityPage(masterActivityPageNumber() - 1)" [disabled]="masterActivityPageNumber() === 0">Previous</button>
      <span>Page {{ masterActivityPageNumber() + 1 }} of {{ page.totalPages }}</span>
      <button type="button" (click)="goToMasterActivityPage(masterActivityPageNumber() + 1)" [disabled]="page.last">Next</button>
    </nav>
  </ng-container>
</dialog>
